export default __webpack_public_path__ + "static/media/patent02-2.fcbfb205.png";